import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom'
import Breadcrumb from '../common/breadcrumb';
import data from '../../assets/data/listUser';
import Datatable from '../common/datatable'
import VerLogLoginDatatable from '../common/ver-log-login-datatable';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';

export class Ver_log_login extends Component {

    constructor(props) {
        super(props);
        this.handler = this.handler.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.state = {
            dataCateg: [],
            results: [],
            filter: '',
            temp: [],
        };
    }

    handler(data_row) {
        this.props.history.push("/edit-user/"+data_row.original.id);
        window.location.reload();
    }

    deleteUser(data_row) {
       Swal.fire({
        title: 'Confirmar',
        text: '¿Desea eliminar '+ data_row.original.Nombre + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33', 
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
     }).then((result) => {
        if(result.value){
            /*let data = myData;
            data.splice(data_row.index, 1);
            this.setState({ myData: data });
            this.deleteUser(row)*/
            var user = AuthService.getCurrentUser();
            ApiService.deleteUser(user.token,data_row.original.id).then(
                (res) => {
                    toast.success("Usuario eliminado!");
                    this.getDataUser();
                    //this.props.history.push("/category");
                    //window.location.reload();
                },
                error => {
                const resMessage =
                    (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
                }
            )
       }
     })
    }

    onChangeFilter(e) {

        this.setState({
            filter: e.target.value
        }, function () {
        });

        const val = e.target.value.toLowerCase();
        if (this.state.temp.length != 0) {
          var columns = Object.keys(this.state.temp[0]);
          //Los botones de acciones se pintan despues
          columns.splice(columns.length);
          //columns.splice(columns.length - 1);
    
          if (!columns.length)
            return;
          const rows = this.state.temp.filter(function (d) {
            for (let i = 0; i <= columns.length; i++) {
              let column = columns[i];
              if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
                return true;
              }
            }
          });
          this.setState({
            results: rows
        }, function () {
            this.renderResults(this.state.results.length);
        });
          /*this.Inventarios = rows;
          let articulosAlmacenes;
          articulosAlmacenes = { 'Articulos': this.Inventarios }
          this.buildpurchaseForm(articulosAlmacenes);*/
        }



        e.preventDefault();
      }
      
    componentWillMount() {
        this.getDataUser();
    }

    getDataUser(){
        var user = AuthService.getCurrentUser();
        ApiService.getBloquedUsers(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = res.data.map(function(row) {
                        return { 
                            id: row.id, 
                            Nombre : row.name + ' ' + row.last_name,
                            Celular : row.Profile?row.Profile.cell_phonenumber:'',
                            Rol : row.role,
                            Pin: row.pin_code,
                        }
                     })
                this.setState({ results:items });
                this.setState({ temp:items });
                this.renderResults(this.state.results.length);
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    renderResults(length){
		return this.state.results.length === 0 
			? 'No hay datos.'
			: <VerLogLoginDatatable
            multiSelectOption={false}
            myData={this.state.results}
            pageSize={length<=50?length:50}
            pagination={true}
            class="-striped -highlight"
            handler = {this.handler}
            deleteUser = {this.deleteUser}
        />
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Intentos de Login" parent="Users" />
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                           {/*<h5>User Details</h5>*/}
                        </div>
                        <div className="card-body">
                            <div className="clearfix"></div>
                            <div id="batchDelete" className="category-table user-list order-table coupon-list-delete">
                            <div className="col-md-6 table-filter">
                            <input 
                                placeholder="Escriba para filtrar todas las columnas"
                                name="filter" 
                                type="text" 
                                className="form-control" 
                                autoComplete="off"
                                onInput={this.onChangeFilter}
                            />
                            </div>
                                {this.renderResults()}
                                {/*<VerLogLoginDatatable
                                    multiSelectOption={true}
                                    myData={data}
                                    pageSize={10}
                                    pagination={true}
                                    class="-striped -highlight"
                                />*/}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Ver_log_login
